import FeatherIcon from "feather-icons-react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { Button, Grid } from "@components/base";
import { useMultistepFormStore } from "@components/common/MultistepForm/MultistepForm.store";
import { useUserStore } from "@store/user";
import { useCreateQuestionConfig } from "@api";

const EditorButtonsBottom: FC = () => {
  const { t } = useTranslation();
  const {
    activeSection,
    formSettings: {
      editMode,
      formBasics: { id },
    },
    setAddQuestionOpen,
    setCreateQuestionOpen,
  } = useMultistepFormStore();
  const { user } = useUserStore();
  const { createQuestionConfigEnabled } = useCreateQuestionConfig(user, id);

  return (
    createQuestionConfigEnabled &&
    activeSection &&
    editMode && (
      <Grid container spacing={2}>
        <Grid size={6}>
          <Button
            variant="outlined"
            startIcon={<FeatherIcon icon="plus-circle" />}
            fullWidth
            onClick={() => setAddQuestionOpen(true)}
          >
            {t("multistep.addQuestion")}
          </Button>
        </Grid>
        <Grid size={6}>
          <Button
            variant="outlined"
            startIcon={<FeatherIcon icon="file-plus" />}
            fullWidth
            onClick={() => setCreateQuestionOpen(true)}
          >
            {t("multistep.createQuestion")}
          </Button>
        </Grid>
      </Grid>
    )
  );
};

export default EditorButtonsBottom;
